import { render, staticRenderFns } from "./FloatingGuide.vue?vue&type=template&id=4b43fafc&scoped=true&"
import script from "./FloatingGuide.vue?vue&type=script&lang=js&"
export * from "./FloatingGuide.vue?vue&type=script&lang=js&"
import style0 from "./FloatingGuide.vue?vue&type=style&index=0&id=4b43fafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43fafc",
  null
  
)

export default component.exports